import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";

export const rolesApi = api
  .enhanceEndpoints({ addTagTypes: ["roles"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      roles: builder.query({
        query: ({ branchId }) => ({
          url: `/branchs/${branchId}/roles`,
          method: RequestMethod.GET,
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data),
        providesTags: ["roles"],
      }),
      createRole: builder.mutation({
        query: ({ branchId, name, baseRole }) => ({
          url: `/branchs/${branchId}/roles`,
          method: RequestMethod.POST,
          body: camelToSnake({
            name,
            baseRole,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data),
        invalidatesTags: ["roles"],
      }),
      updateRole: builder.mutation({
        query: ({ branchId, id, name }) => ({
          url: `/roles/${id}`,
          method: RequestMethod.PUT,
          body: camelToSnake({ name, filialId: branchId }),
        }),
      }),
      rolePermissionRevoke: builder.mutation({
        query: ({ branchId, roleId, permissionId, subgroup, group }) => ({
          url: `/branchs/${branchId}/role-permissions/revoke`,
          method: RequestMethod.POST,
          body: camelToSnake({
            roleId,
            permissionId,
            subgroup,
            group,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data),
        invalidatesTags: ["roles"],
      }),
      rolePermissionAssign: builder.mutation({
        query: ({ branchId, roleId, permissionId, subgroup, group }) => ({
          url: `/branchs/${branchId}/role-permissions/assign`,
          method: RequestMethod.POST,
          body: camelToSnake({
            roleId,
            permissionId,
            subgroup,
            group,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response?.data),
        invalidatesTags: ["roles"],
      }),
    }),
  });

export const {
  useRolesQuery,
  useCreateRoleMutation,
  useRolePermissionAssignMutation,
  useRolePermissionRevokeMutation,
  useUpdateRoleMutation,
} = rolesApi;
